<template>
  <div
    class="h-4 animate-pulse rounded-sm bg-zinc-200/40 duration-700 ease-in"
  />
</template>
